import { Faculty } from "models";
import React from "react";
import { FaEnvelope } from "react-icons/fa";

interface FacultyContactInfoProps {
  /** The alum whose details should be displayed. */
  facultyMember: Faculty;
}

/** Reusable component to display contact information for an alum. */
export function FacultyContactInfo({ facultyMember }: FacultyContactInfoProps): JSX.Element {
  return (
    <div className="secondary-info d-flex flex-column">
      {facultyMember.email && (
        <span>
          <FaEnvelope className="margin-right-9" color="grey" size={21} />
          {facultyMember.email}
        </span>
      )}
      {/* Sue said NO PHONE NUMBERS. In a nice way though. Not like me.
       {facultyMember.phone && (
        <span>
          <i className="fas fa-phone-alt" />
          {standardizePhoneNumber(facultyMember.phone)}
        </span>
      )} */}
    </div>
  );
}
